import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid,
    TableContainer,
    Divider,
    Typography,
} from '@material-ui/core';
import moment from 'moment';
import { useStylesAuth } from '../../../../../styles/auth/style';
import QRCode from 'react-qr-code';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 70,
    },
    align: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    alignDatos: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '.3em',
        textAlign: 'center',
    },
    textObservaciones: {
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '.5em',
        //textAlign: 'left',
        padding: '1em',
        wordBreak: 'break-word',
        textAlign: 'justify',
    },
    paragraphSpacing: {
        marginTop: '0em', // Ajusta el espacio entre párrafos según tus preferencias
    },
    textJustified: {
        textAlign: 'justify', // Aplica justificación al texto
    },
}));

const optionsAño = {
    year: 'numeric',
};

const optionsDia = {
    day: '2-digit'
};

const optionsMes = { month: 'long' };

const optionsHora = {
    hour: '2-digit',
    minute: '2-digit'
};

export const CertificadoAtencion = ({
    handleClose,
    handlePrintRow,
    componentRef,
    modal,
    hceSeleccionada,
    relEfectorCMEspe
}) => {

    const classes = useStyles();
    const classesAuth = useStylesAuth('light');



    const centrosMedicosFiltrados = relEfectorCMEspe
        .filter(item => item.id_centroMedico === hceSeleccionada.idCm)

    console.log(hceSeleccionada)
    return (
        <>
            <TableContainer className={classes.form}>
                <Grid container spacing={2} ref={componentRef}>
                    <Grid item xs={12} className={classes.logo}>
                        <Grid container justify="flex-end">
                            <Grid item xs={6} className={classesAuth.imageInherit} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '1em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid container>
                                <Grid item xs={12} className={classes.align}>
                                    <Typography style={{ fontSize: '1.5em' }} color="primary">
                                        Fecha de Impresion: {moment().format('DD/MM/YYYY')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} className={classes.align}>
                                    <Typography style={{ fontSize: '1.5em', marginTop: 10 }} color="primary">
                                        CERTIFICADO DE ATENCÍON
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '2em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Grid
                            container
                            spacing={2}
                            justify="space-evenly"
                            alignItems="flex-end"
                        >
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <Typography variant="body1">
                                    {`Buenos Aires ${new Date(hceSeleccionada?.horaConfirm).toLocaleString('es', optionsDia)} de ${new Date(hceSeleccionada?.horaConfirm).toLocaleString('es', optionsMes)} , de ${new Date(hceSeleccionada?.horaConfirm).toLocaleString('es', optionsAño)} -  ${centrosMedicosFiltrados[0]?.descripcion_Centro}`}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <Typography variant="body1">
                                    {`Dejo contancia que el Beneficiario/a N°: ${hceSeleccionada.carnet} Sr./Sra ${hceSeleccionada.nombreApellido} 
                                    ha asistido al servicio de: ${hceSeleccionada.descripcionEspecialidad} en el horario de ${new Date(hceSeleccionada?.horaConfirm).toLocaleString('es', optionsHora)}`}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <Typography variant="body1">

                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '2em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Grid
                            container
                            spacing={2}
                            justify="space-evenly"
                            alignItems="flex-end"
                        >
                            <Grid item xs={12} style={{ textAlign: 'center', marginTop: '1em' }}>
                                {/* <Typography variant="body1">
                                    .............................................................
                                </Typography>
                                <Typography variant="body1">
                                    Firma y sello del Profesional
                                </Typography> */}

                                <QRCode
                                    value={`${process.env.REACT_APP_URL_BASE}/afiliado/credenciales/informacion-afiliado/${hceSeleccionada.idAfiliado}`}
                                    size={125}
                                />

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '2em' }}>
                        <Divider />
                    </Grid>
                </Grid>
                {modal && (
                    <Grid
                        item
                        xs={12}
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginTop: '1em',
                        }}
                    >
                        <Button
                            style={{ marginRight: 5 }}
                            onClick={handleClose}
                            variant="contained"
                            color="primary"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handlePrintRow}
                            variant="contained"
                            color="primary"
                            autoFocus
                        >
                            Imprimir
                        </Button>
                    </Grid>
                )}
            </TableContainer>
        </>
    )
}
